import moment from "moment";

import {
  CsvFieldMapping,
  CsvImportField,
  mappedCsvValue,
} from "Components/Common/CsvImport/csvImportTypes";

export const LOA_IMPORT_FIELDS: CsvImportField[] = [
  { key: "ProjectName", label: "Project Name", required: true },
  { key: "SomaliaRegion", label: "Somalia Region", required: true },
  { key: "MinistryDepartmentAgency", label: "Ministry / Department / Agency", required: true },
  { key: "AdministratingAgency", label: "Administrating Agency", required: true },
  { key: "ProjectBudget", label: "Project Budget" },
  { key: "DurationStartDate", label: "Duration: Start Date", required: true },
  { key: "DurationEndDate", label: "Duration: End Date", required: true },
  { key: "NoOfSupportedPositions", label: "No. of Supported Positions" },
  { key: "DataProvidedBy", label: "Data Provided By" },
];

function normalizeDate(value: string | null): string | null {
  if (!value) return null;
  const date = moment(value, ["DD/MM/YYYY", "YYYY-MM-DD"], true);
  return date.isValid() ? date.format("YYYY-MM-DD") : value;
}

export function mapLoaImportRow(
  row: Record<string, string>,
  mappings: CsvFieldMapping
) {
  const get = (key: string) => mappedCsvValue(row, mappings, key);
  return {
    requestTitle: get("ProjectName"),
    region: get("SomaliaRegion"),
    mda: get("MinistryDepartmentAgency"),
    reportingAgency: get("AdministratingAgency"),
    valueOfRequest: get("ProjectBudget"),
    startDate: normalizeDate(get("DurationStartDate")),
    endDate: normalizeDate(get("DurationEndDate")),
    noOfPositionsRequested: get("NoOfSupportedPositions"),
    dataProvidedBy: get("DataProvidedBy"),
  };
}
